import { loadSwiper, observeOnce, pauseAutoplayOnFocus, prefersReducedMotion } from '@kame/lib';

class KameDetailCarousel extends HTMLElement {
  async connectedCallback() {
    const reduced = prefersReducedMotion();
    if (!reduced) {
      this.classList.add('is-armed');
      this.reveal = observeOnce(this, () => this.classList.add('is-inview'), '0px 0px -15% 0px');
    }

    const container = this.querySelector('.swiper');
    const slides = this.querySelectorAll('.swiper-slide');
    if (!container || slides.length < 2) return;
    const Swiper = await loadSwiper(this.dataset.swiperSrc);
    if (!this.isConnected || this.swiper) return;

    const peek = this.dataset.peek === 'true';
    const perView = (Number(this.dataset.perView) || 4) + 0.4;
    const loop = slides.length > perView * 2;
    const dots = this.querySelector('[data-dots]');
    const bounded = peek && !loop;

    this.swiper = new Swiper(container, {
      slidesPerView: peek ? 1.25 : 1.6,
      spaceBetween: 12,
      centeredSlides: peek,
      centeredSlidesBounds: bounded,
      centerInsufficientSlides: bounded,
      loop,
      rewind: !loop,
      speed: reduced ? 0 : 480,
      pagination: Boolean(dots) && {
        el: dots,
        clickable: true,
        bulletElement: 'button',
        bulletClass: 'kame-dc__dot',
        bulletActiveClass: 'is-active',
      },
      autoplay:
        this.dataset.autoplay === 'true' && !reduced
          ? { delay: Number(this.dataset.speed) || 4000, pauseOnMouseEnter: true, disableOnInteraction: false }
          : false,
      breakpoints: {
        750: { slidesPerView: peek ? 2.4 : 3.4, spaceBetween: 20 },
        1100: { slidesPerView: perView, spaceBetween: 28 },
      },
    });

    this.releaseFocus = pauseAutoplayOnFocus(this, this.swiper);
  }

  disconnectedCallback() {
    this.reveal?.disconnect();
    this.releaseFocus?.();
    this.swiper?.destroy(true, true);
    this.swiper = null;
  }
}

if (!customElements.get('kame-detail-carousel')) customElements.define('kame-detail-carousel', KameDetailCarousel);
